import { ChipMolecule } from '@justomx/atlas-components'
import { Icon } from '@justomx/atlas-icons'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { StackAtom } from 'components/atoms/Stack.atom'

const filters = ['bulk', 'cleaning', 'others']

const DEFAULT_ICONS = {
  bulk: <Icon name="ic_bulk" size={20} color="rgb(255, 238, 182)" />,
  cleaning: <Icon name="ic_cleaning" size={20} color="rgb(255, 238, 182)" />,
  others: undefined
}

const SELECTED_ICONS = {
  bulk: <Icon name="ic_bulk" size={20} color="inherit" />,
  cleaning: <Icon name="ic_cleaning" size={20} color="inherit" />,
  others: <Icon name="ic_check" size={20} color="inherit" />
}

interface ProductFiltersOrganismProps {
  onSelectFilter: (filterId: string | undefined) => void
}

export const ProductFiltersOrganism = (props: ProductFiltersOrganismProps) => {
  const { onSelectFilter } = props
  const { t } = useTranslation('global')
  const [filterStates, setFilterStates] = useState<Record<string, boolean>>({
    bulk: false,
    cleaning: false,
    others: false
  })

  const _onSelectFilter = (filterId: string) => {
    const unselect = filterStates[filterId]
    const newState = { ...filterStates }
    Object.entries(filterStates).forEach(([id, selected]) => {
      if (filterId === id) {
        newState[id] = !selected
      } else {
        newState[id] = false
      }
    })
    setFilterStates(newState)
    onSelectFilter(unselect ? undefined : filterId)
  }

  return (
    <StackAtom $gap={16} $justify="center">
      {filters.map((id) => (
        <ChipMolecule
          key={id}
          text={t(`commons.${id}`)}
          icon={filterStates[id] ? SELECTED_ICONS[id] : DEFAULT_ICONS[id]}
          style={{ padding: '6px 16px' }}
          selected={filterStates[id]}
          onClick={() => {
            _onSelectFilter(id)
          }}
        />
      ))}
    </StackAtom>
  )
}
